import React, { useEffect } from 'react'
import emergence from 'emergence.js'

import 'modern-normalize/modern-normalize.css'
import 'prismjs/themes/prism.css'
import 'scss/gatstrap.scss'
import 'animate.css/animate.css'
import 'font-awesome/css/font-awesome.css'

interface Props {
  children?: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }: Props) => {
  useEffect(() => {
    emergence.init()
  })

  return (
    <div>
      {/* <Navibar title={siteMetadata.title} location={location} /> */}
      {children}
      {/* <Footer title={siteMetadata.title} author={siteMetadata.author} /> */}
    </div>
  )
}

export default Layout
